const {CONSUMPTION_TYPE, CONSUMPTION_UNIT, FUEL_TYPE, EFFICIENCY_CLASS} = require('./ConsumptionConstant')
const Range = require("../utils/Range");

class Consumption {

    constructor({
                    co2,
                    vehicleWeight,
                    range,
                    fuel,
                    power,
                    type = CONSUMPTION_TYPE.FUEL,
                    efficiencyClass = EFFICIENCY_CLASS['-'],
                    fuelType
                } = {}) {

        this.co2 = new Range(co2);
        this.vehicleWeight = new Range(vehicleWeight);
        this.range = new Range(range);
        this.fuel = new Range(fuel);
        this.power = new Range(power);
        this.type = CONSUMPTION_TYPE[type] || CONSUMPTION_TYPE.FUEL;
        this.efficiencyClass = EFFICIENCY_CLASS[efficiencyClass] || EFFICIENCY_CLASS['-'];
        this.fuelType = FUEL_TYPE[fuelType] || null;
    }

    static get CONSUMPTION_TYPE() {
        return CONSUMPTION_TYPE
    };

    static get CONSUMPTION_UNIT() {
        return CONSUMPTION_UNIT
    };

    consumptionString(t = (t) => t){
        switch (this.type){
            case CONSUMPTION_TYPE.FUEL:
                return `${this.fuel} l/100km (${t(this.fuelType, {ns: 'translation'})})`
            case CONSUMPTION_TYPE.POWER:
                return `${this.power} kWh/100km`
            case CONSUMPTION_TYPE.HYBRID:
                return `${t('COMBINED', {ns: 'translation'})} ${this.fuel} l/100km & ${this.power} kWh/100km`
        }
    }

    toFirestore() {
        return {
            co2: this.co2.toFirestore ? this.co2.toFirestore() : null,
            vehicleWeight: this.vehicleWeight.toFirestore ? this.vehicleWeight.toFirestore() : null,
            range: this.range.toFirestore ? this.range.toFirestore() : null,
            fuel: this.fuel.toFirestore ? this.fuel.toFirestore() : null,
            power: this.power.toFirestore ? this.power.toFirestore() : null,
            type: this.type,
            efficiencyClass: this.efficiencyClass,
            fuelType: this.fuelType
        }
    }

}

module.exports = Consumption;